import { gql } from 'graphql-request'

export const GetSpeciGql = gql`
  query speci($speciId: UUID!) {
    speci(request: { speciId: $speciId }) {
      speci {
        id
        lines {
          id
          number
          description
          traditionalDescription
          baleNumbers
          instructions
        }
        breeds
        woolStore
        classer
        classerComment
        consignmentStatus
      }
    }
  }
`
